<div class="control-unit">
  <div class="control-unit__header flex flex-col" *ngIf="cascadeDevice">
    <div class="flex flex-row gap-[16px] justify-start items-end">
      <h1>
        {{
          '+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' +
            cascadeDevice.deviceType.toUpperCase() | translate
        }}
        {{ memberId$ | async | value2: featurePropertyKey.value:'' }}
      </h1>
      <h3>{{ externalCANAddress }}</h3>
    </div>
    <p>{{ cascadeDevice.boilerSerial }}</p>
  </div>
  <p *ngIf="parameterIdentification$ | async | ready as parameterIdentification">
    {{ '+INSTALLATIONS.INSTALLATION.CASCADES.MCU_PARAMETER' | translate }}:
    {{ parameterIdentification | value2: featurePropertyKey.value }}
  </p>
  <div
    class="control-unit__container"
    *ngIf="busTopology$ | async | ready as feature; else noFeature"
  >
    <div class="control-unit__table">
      <div class="header-row flex flex-row">
        <div class="title flex-1">
          {{ '+INSTALLATIONS.INSTALLATION.CONTROL_UNITS.TABLE_HEADER.CONTROL_UNIT' | translate }}
        </div>
        <div class="title flex-1">
          {{
            '+INSTALLATIONS.INSTALLATION.CONTROL_UNITS.TABLE_HEADER.BUS_TYPE_BUS_ADDRESS'
              | translate
          }}
        </div>
        <div class="title flex-1">
          {{ '+INSTALLATIONS.INSTALLATION.CONTROL_UNITS.TABLE_HEADER.SERIAL_NUMBER' | translate }}
        </div>
        <div class="title flex-1">
          {{
            '+INSTALLATIONS.INSTALLATION.CONTROL_UNITS.TABLE_HEADER.SOFTWARE_VERSION' | translate
          }}
        </div>
        <div class="title flex-1">
          {{
            '+INSTALLATIONS.INSTALLATION.CONTROL_UNITS.TABLE_HEADER.HARDWARE_VERSION' | translate
          }}
        </div>
      </div>
      <div class="flex flex-col">
        <div class="entry-row flex flex-row" *ngFor="let entry of feature.properties?.value?.value">
          <div class="value flex-1">{{ 'TI_' + entry.deviceObjectProperty | translate }}</div>
          <div class="value flex-1">{{ entry.busType }}/{{ entry.busAddress }}</div>
          <div class="value flex-1">{{ entry.etn }}</div>
          <div class="value flex-1">{{ entry.softwareVersion }}</div>
          <div class="value flex-1">{{ entry.hardwareVersion }}</div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noFeature>
    <div class="not-supported-device">
      {{ '+INSTALLATIONS.INSTALLATION.CONTROL_UNITS.FEATURE_NOT_SUPPORTED_MESSAGE' | translate }}
    </div>
  </ng-template>
</div>
